import(/* webpackMode: "eager" */ "/vercel/path0/app/projects/page.tsx");
